import { render, staticRenderFns } from "./MansoryGallerySection.vue?vue&type=template&id=63e2e25e&"
import script from "./MansoryGallerySection.vue?vue&type=script&lang=js&"
export * from "./MansoryGallerySection.vue?vue&type=script&lang=js&"
import style0 from "./MansoryGallerySection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports